import { NgbDate } from '@ng-bootstrap/ng-bootstrap';

export const limitateForFutureDate = (): NgbDate => {
  const now = new Date();
  return new NgbDate(now.getFullYear(), now.getMonth() + 1, now.getDate());
};
